import { render, staticRenderFns } from "./CollectingDetail.vue?vue&type=template&id=7468c044"
import script from "./CollectingDetail.vue?vue&type=script&lang=js"
export * from "./CollectingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports